import { styled } from "@mui/material/styles";

import ResponsiveImage from "components/ResponsiveImage";

export const Root = styled("div")({
  background: "linear-gradient(90deg, #5B9DFE, #85ECF1)",
  width: "100%",
  display: "flex",
  justifyContent: "center",
});

export const Banner = styled(ResponsiveImage)({
  maxWidth: "100%",
});
